import LandingPageCRUDActions from '@mm/state/actions/LandingPageCRUDActions';
import { unselectLandingPage } from '@mm/state/actions/viewActions';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import React from 'react';
import { connect } from 'react-redux';
import { ButtonGroup } from 'reactstrap';
import { compose, mapProps, withHandlers } from 'recompose';
import Button from '../../../../../common/buttons/DeprecatedButton/DeprecatedButton';
import { BotBuilderRoutes } from '../../../../../routes/bot-builder-routes';
import { isValidForS3 } from '../../../common/helpers/isValidForS3/isValidForS3';
import {
  INVALID_LINK_SLUG_ERROR,
  SHORT_LINK_SLUG_ERROR,
  UNIQUE_LINK_SLUG_ERROR,
} from '../../constants/constants';
import LandingPageDesign from '../LandingPageDesign/LandingPageDesign';
import '../LandingPageDetails/LandingPageDetails.scss';
import LandingPageProperties from '../LandingPageProperties/LandingPageProperties';

const LandingPagePropertiesSideBar = props => {
  const {
    showDetailsTab,
    toggleShownTab,
    validateLinkSlug,
    LandingPagePropertiesProps,
    LandingPageDesignProps,
    onSave,
    onCancel,
  } = props;

  if (validateLinkSlug) validateLinkSlug();

  return (
    <div>
      <ButtonGroup>
        <Button
          purple
          className="landing-page-details__tab-button"
          invert={!showDetailsTab}
          onClick={toggleShownTab}
        >
          Details
        </Button>
        <Button
          purple
          invert={showDetailsTab}
          className="landing-page-details__tab-button"
          onClick={toggleShownTab}
        >
          Design
        </Button>
      </ButtonGroup>
      {showDetailsTab ? (
        <LandingPageProperties {...LandingPagePropertiesProps} />
      ) : (
        <LandingPageDesign {...LandingPageDesignProps} />
      )}
      <div>
        <ButtonGroup>
          <Button
            className="landing-page-details__button"
            disabled={
              !!LandingPagePropertiesProps.formLinkSlugError ||
              !LandingPagePropertiesProps.formName ||
              LandingPagePropertiesProps.formName.length < 1
            }
            onClick={onSave}
          >
            Save
          </Button>
          <Button
            invert
            className="landing-page-details__button"
            onClick={onCancel}
          >
            Cancel
          </Button>
        </ButtonGroup>
      </div>
    </div>
  );
};

const validateLinkSlug = props => () => {
  const {
    entities = [],
    formLinkSlug,
    updateFormLinkSlugError,
    selectedEntity,
  } = props;

  if (!formLinkSlug || formLinkSlug.length < 1) {
    return updateFormLinkSlugError(SHORT_LINK_SLUG_ERROR);
  }
  const hasDuplicates = entities.some(
    e => e.slug === formLinkSlug && e.id !== selectedEntity.id,
  );
  if (hasDuplicates) {
    return updateFormLinkSlugError(UNIQUE_LINK_SLUG_ERROR);
  }
  if (!isValidForS3(formLinkSlug)) {
    return updateFormLinkSlugError(INVALID_LINK_SLUG_ERROR);
  }
  return updateFormLinkSlugError('');
};

const mapStateToProps = state => ({
  entities: state.landingPages.entities.sort(
    (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
  ),
  chatbotId: activeChatbotIdSelector(state),
});

const mapDispatchToProps = dispatch => ({
  updateSelectedEntity: (botId, entity) =>
    dispatch(LandingPageCRUDActions.update(botId, entity)),
  clearSelectedLandingPage: () => dispatch(unselectLandingPage()),
});

const propsMapper = ownerProps => {
  const {
    formName,
    updateFormName,
    formLinkSlug,
    updateFormLinkSlug,
    formLinkSlugError,
    formPageId,
    updateFormPageId,
    formPageHeading,
    updateFormPageHeading,
    formPageText,
    updateFormPageText,
    chatbotId,
    validateLinkSlug,
    ...restProps
  } = ownerProps;

  const landingBaseUrl =
    ownerProps.selectedEntity && ownerProps.selectedEntity.landingBaseUrl;

  const LandingPagePropertiesProps = {
    formName,
    updateFormName,
    landingBaseUrl,
    formLinkSlug,
    updateFormLinkSlug,
    formLinkSlugError,
    formPageId,
    updateFormPageId,
    validateLinkSlug,
    formLink:
      formLinkSlug && `${landingBaseUrl}${chatbotId}/${formLinkSlug}.html`,
  };

  return {
    LandingPagePropertiesProps,
    validateLinkSlug,
    ...restProps,
  };
};

const onSave = props => () => {
  const {
    formPageId,
    formName,
    formLinkSlug,
    formPageHeading,
    formPageText,
    formBgColor,
    selectedEntity,
    updateSelectedEntity,
    formImageNewUrl,
    chatbotId,
    setFormImageNewUrl,
    formImageUrl,
    formTextAlignment,
    formMsgButtonText,
  } = props;

  const updatedEntity = Object.assign({}, selectedEntity, {
    pageId: formPageId,
    name: formName.trim(),
    slug: formLinkSlug,
    heading: formPageHeading,
    text: formPageText,
    color: formBgColor,
    imageUrl: formImageUrl,
    newImageUrl:
      formImageNewUrl && formImageNewUrl.slice(0, formImageNewUrl.indexOf('?')),
    textAlignment: formTextAlignment,
    msgButtonText: formMsgButtonText,
  });
  updateSelectedEntity(chatbotId, updatedEntity);
  setFormImageNewUrl('');
};

const onCancel = props => () => {
  const { history, chatbotId, clearSelectedLandingPage } = props;
  clearSelectedLandingPage();

  const pathname = BotBuilderRoutes.chatStarters.getLink({
    chatbotId,
    kind: 'landing_pages',
  });
  if (pathname) {
    history.push(pathname);
  }
};

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onTabClick: props => () => props.toggleShownTab(),
    onSave,
    onCancel,
    validateLinkSlug,
  }),
  mapProps(propsMapper),
);

export default enhance(LandingPagePropertiesSideBar);
